// prep Fixel data
const calcChange = (current, prev) => {
    const change = Math.round((100 * (current - prev)) / prev);
    return isNaN(change) ? null : change;
};

const prepFixelData = (segmentStats) => {
    return {
        code: segmentStats.code,
        total: segmentStats.current.total,
        totalChange: calcChange(segmentStats.current.total, segmentStats.previous.total),
        Engaged: segmentStats.current.basic,
        EngagedChange: calcChange(segmentStats.current.basic, segmentStats.previous.basic),
        highEngaged: segmentStats.current.high,
        highEngagedChange: calcChange(segmentStats.current.high, segmentStats.previous.high),
    };
};
const prepFixelFullRes = (fixelRes) => {
    if (!fixelRes.TODAY) {
        return fixelRes;
    }

    const fullData = {
        code: fixelRes.TODAY[0].code,
        state: fixelRes.TODAY[0].state,
        display: fixelRes.TODAY[0].display,
        install_data: fixelRes.TODAY[0].install_data,
        plan: fixelRes.TODAY[0].plan,
        last_state_change: fixelRes.TODAY[0].last_state_change,
        conversions: fixelRes.LAST_30_DAYS[0].conversions,
    };

    for (const timeFrame in fixelRes) {
        fullData[timeFrame] = {
            conversions: fixelRes[timeFrame][0].conversions,
            fixelStats: prepFixelData({
                code: fixelRes[timeFrame][0].code,
                current: fixelRes[timeFrame][0].current,
                previous: fixelRes[timeFrame][0].previous,
            }),
        };
    }
    return fullData;
};

export default prepFixelFullRes;